module.exports = __webpack_public_path__ + "img/PVProductionService.80dda4fd.png";